import React from 'react';
import { DialogContent, DialogActions } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle/DialogTitle';
import Divider from '@mui/material/Divider';
import { MemoShortCompanyForm } from 'components/company/Form';
import { useCreateCompany } from 'components/dataCreationForms/company/withCreateCompany';
import { WithInputForm } from 'components/dataCreationForms/withInputForm';
import { DialogButtons } from 'components/general/ButtonsPanel/ButtonsPanel';
import { useFormCleanupOnUnmount } from 'presentation/dialogForms/dialogFormsHooks';
import { memo } from 'react';
import { FormattedMessage } from 'intl';
import { ProjectSetupTranslationKeys } from 'intl/keys';
import { companyDialogSx } from '../styles';


function CreateCompanyWizardDialog(): React.ReactElement {
  const {
    open,
    closeDialog,
    submitForm,
    isPosting,
    initialValues,
    releaseSubmitEvent,
    SUBMIT_EVENT_TYPE,
    handleFormValidation,
    validate,
    availableSites,
  } = useCreateCompany();
  const formName = 'company';
  useFormCleanupOnUnmount(formName);

  return (
    <Dialog
      open={open}
      fullWidth
      onClose={closeDialog}
      sx={companyDialogSx}
    >
      <WithInputForm
        values={initialValues}
        errors={{}}
        handleFormValidation={handleFormValidation}
        handleFieldValidation={validate}
        onSubmit={submitForm}
        eventType={SUBMIT_EVENT_TYPE}
        dispatchSubmit={releaseSubmitEvent}
        formName={formName}
      >
        <DialogTitle>
          <FormattedMessage id={ProjectSetupTranslationKeys.addCompanySection} />
        </DialogTitle>
        <Divider />

        <DialogContent>
          <MemoShortCompanyForm
            sites={availableSites}
            isDialog={true}
            initialValues={initialValues}
          />
        </DialogContent>
        <Divider />
        <DialogActions>
          <DialogButtons
            isPosting={isPosting}
            onSubmit={releaseSubmitEvent}
            onCancel={closeDialog}
          />
        </DialogActions>
      </WithInputForm>
    </Dialog>
  );
}

export const MemoCreateCompanyWizardDialog = memo(
  CreateCompanyWizardDialog
);
